<span part="icon" #iconContainer></span>
